export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/house.afbfc79.svg";